/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Home_Artifacts_UnavailableInputs */



/**
* | output |
* | --- |
* | "{count} of the selected artifacts are no longer available and were not added." |
*
* @param {Home_Artifacts_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const home_artifacts_unavailable = /** @type {((inputs: Home_Artifacts_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artifacts_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} der ausgewählten Artefakte sind nicht mehr verfügbar und wurden nicht hinzugefügt.`)
	return /** @type {LocalizedString} */ (`${i?.count} of the selected artifacts are no longer available and were not added.`)
});